<template>
    <div
        id="cookiesBanner"
        class="cookies-banner"
        :class="{'hidden': !isVisible}">
        <p class="cookies-banner__text">{{ $t('cookie-banner-message') }} <a :href="knowMoreUrl">{{ $t("find-out-more") }}</a></p>
        <ul class="buttons-list buttons-list--row buttons-list--right">
            <li class="buttons-list__item">
                <button
                    @click="rejectAllCookies"
                    id="rejectAllCookiesButton"
                    type="button"
                    class="button button--secondary">
                    {{ $t("reject-all") }}
                </button>
            </li>
            <li class="buttons-list__item">
                <button
                    @click="acceptAllCookies"
                    id="acceptAllCookiesButton"
                    type="button"
                    class="button button--primary">
                    {{ $t("accept-all") }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
// @ is an alias to /src
import { purify } from "@/utils/helpers/string.js";
import { setCookie, getCookie } from "@/utils/helpers/cookie";

export default {
    name: "CookiesBanner",
    data() {
        return {
            isVisible: false
        };
    },
    computed: {
        // user
        // Current logged user
        knowMoreUrl() {

            switch(this.$i18n.locale) {
            case "en":
                return process.env.VUE_APP_LANDIND_PAGE_URL + "/en/cookies-policy.html";
            case "fr":
            default:
                return process.env.VUE_APP_LANDIND_PAGE_URL + "/fr/politique-de-cookies.html";
            }
        },
    },
    mounted: function() {
        this.init();
    },
    methods: {
        init: function () {
            var cookiesAccepted = getCookie("COOKIES_ACCEPTED");

            if (cookiesAccepted === undefined) {
                this.displayBanner();
            }

            if (cookiesAccepted === true) {
                this.startAnalytics();
            }
        },
        displayBanner: function() {
            this.isVisible = true;
        },
        hideBanner: function() {
            this.isVisible = false;
        },
        acceptAllCookies: function() {
            var domain = "localhost";
            if(process.env.VUE_APP_ENVIRONMENT_NAME != "local"){
                domain = process.env.VUE_APP_ROOT_URL;
            }
            setCookie("COOKIES_ACCEPTED", true, {"path": "/", "domain": domain, "httponly": false, "expires": 525600, "samesite": "Strict", "secure": false});
            this.startAnalytics();
            this.hideBanner();
        },
        rejectAllCookies: function() {
            this.hideBanner();
        },
        startAnalytics: function() {
            window.dataLayer = window.dataLayer || [];
            function gtag(){window.dataLayer.push(arguments);}
            gtag("js", new Date());

            gtag("config", "G-JR6R9CPGQY");
        }
    }
};
</script>